import mixpanel from 'mixpanel-browser'

if (false) {
  mixpanel.init('e608ccade885e850a86efc9c098cd296', {
    track_pageview: true,
    persistence: 'localStorage',
  })
}

export const Mixpanel = {
  identify: (id: string) => {
    if (false) mixpanel.identify(id)
    else console.log('Mixpanel.identify', id)
  },
  alias: (id: string) => {
    if (false) mixpanel.alias(id)
    else console.log('Mixpanel.alias', id)
  },
  track: (name: string, props?: object) => {
    if (false) mixpanel.track(name, props)
    else console.log('Mixpanel.track', name, props)
  },
  reset: () => {
    if (false) mixpanel.reset()
    else console.log('Mixpanel.reset')
  },
  people: {
    set: (props: object) => {
      if (false) mixpanel.people.set(props)
      else console.log('Mixpanel.people.set', props)
    },
  },
}
